
const _convertArrayToOptions = list => {
    return (list || []).map((item, i) => Object.assign({},{
        value: i + 1,
        label: item
    }));
};

const _convertObjectToOptions = (list, shouldParseKeys) => {
    return Object.keys(list).map((key => Object.assign({},{
        value: shouldParseKeys ? parseInt(key) : key,
        label: list[key]
    })));
}

/**
 * Converts an array or object to an array with { value, label } object options for using on question types
 * @param {Array|Object} list - object to convert into options array
 * @param {boolean} shouldParseKeys - if true, object keys will use parseInt
 * @return {Array}
 */
const convertToOptions = (list, shouldParseKeys = false) => {
    return Array.isArray(list) ? _convertArrayToOptions(list) : _convertObjectToOptions(list, shouldParseKeys);
};

/**
 * Converts a string to JSON
 * @param data - encoded data string
 * @return {any}
 */
const decodeIfEncoded = data => {
    if ( typeof data === 'string') {
        return JSON.parse(data);
    }
    return data;
}

/**
 * Attempts to parse a value, if it fails, returns the default value
 * @param valueToParse - string to parse into JSON
 * @param defaultValue - default value if parsing fails
 * @returns {*}
 */
const tryToParse = (valueToParse, defaultValue) => {
    try {
        return JSON.parse(valueToParse);
    } catch (e) {
        console.warn(`Unable to parse value: ${valueToParse}`, e);
        return defaultValue;
    }
}

/**
 *
 * @param {[]} array = array to move around
 * @param {int} fromIndex - index to move
 * @param {int} targetIndex - spot to move to
 * @returns {*}
 */
const moveArrayItem = (array, fromIndex, targetIndex) => {
    const result = [...array];
    const itemToReInsert = result.splice(fromIndex, 1)[0];
    result.splice(targetIndex, 0, itemToReInsert);
    return result;
}

export {
    convertToOptions,
    decodeIfEncoded,
    tryToParse,
    moveArrayItem
}
